import { FunnelConversationDocument } from 'src/api/generated/models/FunnelConversationDocument';
import { SpeedDialerQueueItem } from 'src/modules/communications/types/speed-dialer.type';
import { formatFullName } from 'src/modules/shared/utils/formatting/name.util';

export const queueFromConversations = (
  conversations: FunnelConversationDocument[]
): SpeedDialerQueueItem[] => {
  return conversations
    .map((conversation) => {
      const conversationContact = conversation.contacts?.[0];
      if (!conversationContact) return null;

      const validAddresses = (conversationContact.addresses || []).filter(
        (address) => ['PHONE', 'WHATSAPP'].includes(address.channelType)
      );

      const phoneNumbers = validAddresses.map((address) => address.address);

      if (phoneNumbers.length === 0) return null;

      const phoneAddressIds = validAddresses.map((address) => address.id);

      return {
        conversationId: conversation.id,
        phoneNumbers,
        contactLabel: formatFullName(
          conversationContact.firstName,
          conversationContact.lastName,
          'Sin nombre'
        ),
        phoneAddressIds,
      };
    })
    .filter((item) => item !== null) as SpeedDialerQueueItem[];
};
